var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTgWhite = function SvgTgWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    fillRule: "evenodd",
    d: "M1.237 8.888Q8.485 5.5 10.903 4.422c4.603-2.053 5.56-2.41 6.183-2.422.137-.002.444.034.642.207.168.146.214.343.236.481.022.139.05.454.028.7-.25 2.811-1.329 9.633-1.878 12.781-.232 1.333-.69 1.78-1.133 1.823-.962.095-1.693-.682-2.625-1.338-1.459-1.025-2.283-1.664-3.7-2.665-1.636-1.156-.575-1.792.358-2.831.244-.272 4.485-4.41 4.567-4.785.01-.047.02-.222-.077-.314s-.24-.06-.343-.036q-.22.054-6.992 4.957-.992.73-1.797.712c-.592-.014-1.73-.359-2.577-.654-1.038-.362-1.862-.553-1.79-1.168q.056-.48 1.232-.982",
    clipRule: "evenodd"
  })));
};
export default SvgTgWhite;